import axios from "axios";
import { getCookie } from "utils/setCookie";

export const getReportRevenue = async (params: {
  status: "success" | string;
  product_id?: string;
  type?: string;
  order_by?: "DESC" | "ASC";
  limit?: number;
  page?: number;
}) => {
  const url = `${process.env.REACT_APP_AJAX_URL}order/list`;
  const axiosConfig = {
    headers: {
      "X-Authorization": getCookie("session"),
    },
    params,
  };
  try {
    const response = await axios.get(url, axiosConfig);
    return response;
  } catch (error: any) {
    console.error("Failed ", error);
    throw new Error(
      "Failed : " + (error.response?.data?.message || error.message)
    );
  }
};
export const getUserAccessAccount = async () => {
  const url = `${process.env.REACT_APP_AJAX_URL}user/access-count`;
  const axiosConfig = {
    headers: {
      "X-Authorization": getCookie("session"),
    },
    // params,
  };
  try {
    const response = await axios.get(url, axiosConfig);
    return response;
  } catch (error: any) {
    console.error("Failed ", error);
    throw new Error(
      "Failed : " + (error.response?.data?.message || error.message)
    );
  }
};
export const getListUser = async (params: {
  limit: number;
  page: number;
  user_role?: string;
}) => {
  const url = `${process.env.REACT_APP_AJAX_URL}user/list`;
  const axiosConfig = {
    headers: {
      "X-Authorization": getCookie("session"),
    },
    params,
  };
  try {
    const response = await axios.get(url, axiosConfig);
    return response;
  } catch (error: any) {
    console.error("Failed ", error);
    throw new Error(
      "Failed : " + (error.response?.data?.message || error.message)
    );
  }
};
